import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useValidateEmailUserQuery } from '../utils/store/myaccount/myAccountApi';
import { toast } from 'react-toastify';
import { getErrorMessage } from '../utils/functions/functions';
import { Box, Skeleton, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../utils/store';
import { handleLogout } from '../utils/store/auth/AuthSlice';

const ValidateEmailLink = () => {
  const params = new URLSearchParams(window.location.search);
  const patient_id = params.get('id');
  const token = params.get('token');
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const shouldSkip = !patient_id || !token;

  const { data, isLoading, isError, error, isSuccess } = useValidateEmailUserQuery(
    { patient_id, token },
    { skip: shouldSkip }
  );

  useEffect(() => {
    if (isError && error) {
      toast.error(getErrorMessage(error));
    }
  }, [isError, error]);
  useEffect(() => {
    if (isSuccess && data?.status === 200) {
      toast.success('Email verified! Redirecting to login to claim your offer...');
      const timeout = setTimeout(() => {
        dispatch(handleLogout());
        navigate('/login');
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [isSuccess, data, dispatch, navigate]);
  

  if (shouldSkip) {
    return (
      <div className="AllPageMain">
        <div className="container">
          <div className="thankYouPage">
            <Typography variant="h6" color="error">
              Invalid or expired verification link.
            </Typography>
            <button
              className="outLineButton outLineButtonSameheight"
              onClick={() => navigate('/')}
            >
              Continue shopping
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="AllPageMain">
      <div className="container">
        {isLoading ? (
          <Box width="100%" m={2} p={4} className="skeletonBox">
            <Skeleton
              variant="rectangular"
              width="100%"
              height={183}
              className="skeletonStyle"
            />
          </Box>
        ) : (
          <div className="thankYouPage">
            <Typography variant="h5" gutterBottom>
              Email successfully verified!
            </Typography>
            <button
              className="outLineButton outLineButtonSameheight"
              onClick={() => navigate('/')}
            >
              Continue shopping
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ValidateEmailLink;
